export enum ListSortDirection {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
};
